import styled from 'styled-components';
import { vars } from '../../theme';

export const TimezoneRoot = styled.span<{ $borderRadius: string }>`
    display: inline-flex;
    vertical-align: baseline;
    border-radius: ${({ $borderRadius }) => $borderRadius};

    &:focus {
        outline: none;
    }

    &:focus-visible {
        outline: 2px solid ${vars.colors.stroke.keyboardFocus};
        outline-offset: 2px;
    }
`;
